import {EventEmitter} from 'eventemitter3'

export const calendarItemEvent = new EventEmitter()

export const calendarItemEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
}

export function getCalendarItemEventKey(eventType) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case calendarItemEventTypes.TABLE_CHANGE:
            return `CALENDAR_ITEM_TABLE_CHANGE`

        default:
            return ''
    }
}

//#region TABLE CHANGE
export function onCalendarItemTableChangeListener(
    eventType = calendarItemEventTypes.TABLE_CHANGE,
    data,
) {
    calendarItemEvent.emit(getCalendarItemEventKey(eventType), data)
}

export function onCalendarItemTableChangeRemoveListener(
    eventType = calendarItemEventTypes.TABLE_CHANGE,
) {
    calendarItemEvent.removeListener(getCalendarItemEventKey(eventType))
}
//#endregion
